export default __webpack_public_path__ + "static/compactors-jcb-faad0e86bf2092d45dc80287c2d58217.png";